import React from 'react'
import styled from 'styled-components'

import TransitionMantineTooltip from '../TransitionMantineTooltip'

type TDisabled = {
  children?: React.ReactNode
  disabled?: boolean
  tooltip?: React.ReactNode
}
const Wrapper = styled.div`
  position: relative;
`

const Inner = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  cursor: not-allowed;
  // background: rgba(200, 200, 200, 0.5);
`

const Disabled = (props: TDisabled): React.ReactElement => {
  const { children = [], disabled = true, tooltip = '' } = props

  if (!disabled) {
    return children as React.ReactElement
  }

  return (
    <TransitionMantineTooltip tooltip={tooltip}>
      <Wrapper className="text-muted">
        {children}
        <Inner />
      </Wrapper>
    </TransitionMantineTooltip>
  )
}

export default Disabled
